import React from 'react';
import { cartClass, partClass, rootClass } from '@/react/data';
import { useCartContext } from '@/react/store/context';
import CalcCartTable from '@/react/temps/CalcCartTable';
import { rewriteCart } from '@/react/store/reducer';
const CalcCartEmpty = () => (React.createElement("div", { className: `${partClass}__emptyCart`, style: { display: 'block' } },
    React.createElement("p", { style: { marginBottom: '0' } }, "\u0412\u0430\u0448\u0430 \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u0443\u0441\u0442\u0430. \u041C\u044B \u0436\u0434\u0435\u043C \u0412\u0430\u0448\u0438 \u0437\u0430\u044F\u0432\u043A\u0438.")));
const CalcCartTitle = () => (React.createElement("div", { className: `${cartClass}__title` },
    React.createElement("p", { style: { margin: '0' } }, "\u041A\u043E\u0440\u0437\u0438\u043D\u0430 \u0442\u043E\u0432\u0430\u0440\u043E\u0432 / \u0421\u043F\u0435\u0446\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430 / \u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u043E\u0432\u043A\u0430 \u043D\u0430 \u043E\u0431\u044A\u0435\u043A\u0442")));
const CalcCartButtons = () => {
    const [, dispatch] = useCartContext();
    function clearCalcCart() {
        const msg = 'Вы действительно хотите очистить корзину?';
        if (!window.confirm(msg))
            return;
        dispatch(rewriteCart([]));
    }
    return (React.createElement("div", { className: `${cartClass}__buttons`, style: { padding: '0 15px' } },
        React.createElement("span", { className: `${rootClass}__btn ${rootClass}__deleteBtn`, onClick: clearCalcCart }, "\u2716\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043A\u043E\u0440\u0437\u0438\u043D\u0443\u2716"),
        React.createElement("a", { href: window.calcData.popupId, className: `${rootClass}__btn ${rootClass}__sendBtn fancybox`, onClick: () => window.setSpecificCustom() }, "\uD83D\uDCB8\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437\uD83D\uDCB8")));
};
const CalcCart = () => {
    const [{ cart }] = useCartContext();
    return (React.createElement("div", { className: partClass, style: { padding: '25px 0' } }, cart.length === 0
        ? React.createElement(CalcCartEmpty, null)
        : (React.createElement("div", { className: `${partClass}__body`, style: { display: 'block' } },
            React.createElement(CalcCartTitle, null),
            React.createElement(CalcCartTable, null),
            React.createElement(CalcCartButtons, null)))));
};
export default CalcCart;
